<div class="loading-overlay" [hidden]="(isLoading | async) === false">
	<img class="spinner" src="./assets/spinner2.gif" />
</div>

<div class="service-header-wrapper">
	<h2 class="mat-heading">{{ 'masterdata.palletising.pallets.pallets' | translate }}</h2>
	<div class="service-header-buttons">
		<div class="acies-density-high acies-list-search-field">
			<mat-form-field>
				<input matInput [placeholder]="'masterdata.palletising.pallets.search' | translate" [(ngModel)]="searchFilter" />
				<button mat-icon-button matPrefix>
					<mat-icon svgIcon="acies_search"></mat-icon>
				</button>
			</mat-form-field>
		</div>
		<button mat-button (click)="applyActiveOnlyFilter()" style="margin-right: 16px">
			<mat-icon svgIcon="{{ activeOnly ? 'acies_check' : 'acies_uncheck' }}" style="margin-right: 8px"></mat-icon>
			{{ 'insights.administration.reports.onlyactive' | translate }}
		</button>
		<header-sub-menu [favoriteItems]="favoriteItems" [menuItems]="menuItems"></header-sub-menu>
	</div>
</div>

<app-generictable [hidden]="(count | async) <= 0" [tableSource]="tableSource" [tableColumns]="registerTableColumns" [filterWord]="searchFilter" [rowActions]="regRowActions" [selectActions]="selectActions" (menuEmitter)="handleRowMenuAction($event)"></app-generictable>
